import { PageResponseVm } from 'api/core/page-response.vm';
import { GetWorkerVm } from './get-worker.vm';
import { IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class GetWorkersVm extends PageResponseVm<GetWorkerVm, string> {
    @IsString()
    nextOffset: string | null;

    @ValidateNested({ each: true })
    @Type(() => GetWorkerVm)
    objects: GetWorkerVm[];
}
